import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { persistUtmFromUrl } from "@/lib/utmAttribution";

/** Captures utm_* query params on every public navigation (first-touch). */
export function UtmCapture() {
  const location = useLocation();

  useEffect(() => {
    persistUtmFromUrl();
  }, [location.search, location.pathname]);

  return null;
}
